import Input from "../../../../../components/general/input/Input";
import {useRef} from "react";
import TextArea from "../../../../../components/general/input/TextArea";
import useCheckoutStore from "../../../../cart/store/checkoutStore";
import useSession from "../../../../services/state/session/useSession";

const CartOrder = () => {

    const session = useSession();

    const ref = useRef({});
    const updateOrderFn = useCheckoutStore(state => state.updateOrder)
    const updateOrder = (f,a,b) => {
        console.log("a,b", a,b)
        if(a !== b)
            updateOrderFn(session, f, a);
    }

    const currentRef = useCheckoutStore(state => state.order?.POReference);
    const currentPromo = useCheckoutStore(state => state.order?.PromotionCode);
    const currentNote = useCheckoutStore(state => state.order?.X_DeliveryNote);
    const documentNo = useCheckoutStore(state => state.order?.DocumentNo);

    return (
        <>
            <div className="cart-info-split">
                <p className="cart-h">Order</p>
                <p className="cart-h">{documentNo}</p>
            </div>
            <Input
                defaultValue={currentRef}
                hint="Order Reference"
                type="text"
                className="cart-input"
                onChange={(e) => {
                    ref.current.ref = e.target.value;
                }}
                onBlur={() => updateOrder("POReference", ref.current.ref, currentRef)}
            />
            <Input
                defaultValue={currentPromo}
                hint="Promotion Code"
                className="cart-input"
                onChange={(e) => {
                    ref.current.promo = e.target.value;
                }}
                onBlur={() => updateOrder("PromotionCode", ref.current.promo, currentPromo)}
            />
            <TextArea
                defaultValue={currentNote}
                hint="Delivery Note (You can also add a note to the location for info that applies to all deliveries, like access or hours.)"
                className="cart-input"
                onChange={(e) => {
                    ref.current.delivery = e.target.value;
                }}
                onBlur={() => updateOrder("X_DeliveryNote", ref.current.delivery, currentPromo)}
            />
        </>
    )

}

export default CartOrder;
